import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/portfolio',
		component: Base,
		children: [
			{
				path: '',
				name: 'PortfolioList',
				component: List,
				meta: {
					path: '/site/portfolio',
					pai: 'Site',
					title: 'Admin - Portfólio',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Portfólio',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PortfolioNovo',
				component: Form,
				meta: {
					path: '/site/portfolio',
					pai: 'Site',
					title: 'Admin - Portfólio - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Portfólio',
						class: '',
						active: false,
						url: '/site/portfolio'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PortfolioEditar',
				component: Form,
				meta: {
					path: '/site/portfolio',
					pai: 'Site',
					title: 'Admin - Portfólio - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Portfólio',
						class: '',
						active: false,
						url: '/site/portfolio'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]